import ConfirmIcon from '~/assets/icons/icon-warning-green.png';
import SuccesIcon from '~/assets/icons/icon-sucess.svg';

export const modalConfirm = {
  html: `<div><div class="headerModalIndicador">
          <img src=${ConfirmIcon} /><h2>Por favor, <span>confirme a
          submissão dos dados.</span> </h2></div>
        </div>`,
  showCancelButton: true,
  confirmButtonColor: '#74a50a',
  cancelButtonColor: '',
  confirmButtonText: 'Submeter',
  cancelButtonText: 'Ainda não',
  customClass: {
    container: 'container-modal-confirm-perfil',
    confirmButton: 'confirm-button-container-modal-confirm-perfil',
    cancelButton: 'cancel-button-container-modal-confirm-perfil',
  },
};

export const modalSuccess = {
  html: `<div>
          <div class="headerModalIndicador">
          <img src=${SuccesIcon} /><h2> <span> Formulário enviado </span> com sucesso! </div>
        </div>`,
  showCancelButton: false,
  confirmButtonColor: '#74a50a',
  cancelButtonColor: '',
  confirmButtonText: 'Ok! Obrigado!',
  customClass: {
    container: 'container-modal-switch-indicadores-confirm',
    confirmButton: 'confirm-button-switch-indicadores-confirm',
    cancelButton: 'cancel-button-switch-indicadores-confirm',
  },
};

export const modalUpdateSuccess = {
  html: `<div>
          <div class="headerModalIndicador">
          <img src=${SuccesIcon} /><h2> <span> Formulário atualizado </span> com sucesso! </div>
        </div>`,
  showCancelButton: false,
  confirmButtonColor: '#74a50a',
  cancelButtonColor: '',
  confirmButtonText: 'Ok! Obrigado!',
  customClass: {
    container: 'container-modal-switch-indicadores-confirm',
    confirmButton: 'confirm-button-switch-indicadores-confirm',
    cancelButton: 'cancel-button-switch-indicadores-confirm',
  },
};
